// Lead sources. The relay.contacts/companies.source column is free text (no
// enum CHECK as of 20260601150000) — values are either one of these built-in
// tokens or an org-defined custom source from relay.lead_sources.

// Sources a user can pick manually in the UI.
export const SELECTABLE_BUILT_IN_SOURCES = [
  "manual",
  "referral",
  "social",
  "website",
  "event",
  "advertisement",
] as const;

// Display labels for known tokens, including system-assigned sources
// (import/api/booking/document) that are set programmatically rather than
// chosen, but still need a friendly label when shown on a record.
const LABELS: Record<string, string> = {
  manual: "Manual",
  referral: "Referral",
  social: "Social media",
  website: "Website",
  event: "Event",
  advertisement: "Advertisement",
  import: "Import",
  booking: "Booking",
  api: "API",
  document: "Document",
};

/** Friendly label for a source value; custom sources display as entered. */
export function leadSourceLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return LABELS[value] ?? value;
}


const BUILT_IN_SOURCE_ALIASES: Record<string, string> = {
  manual: "manual",
  referral: "referral",
  social: "social",
  "social media": "social",
  website: "website",
  event: "event",
  advertisement: "advertisement",
  import: "import",
  booking: "booking",
  api: "api",
  document: "document",
};

/**
 * Canonicalize user/import-provided lead sources. Known built-ins are stored
 * as lowercase tokens, while unknown values are preserved as custom source
 * names exactly as entered after trimming.
 */
export function normalizeLeadSourceInput(
  value: string | null | undefined,
  fallback: string,
): string {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return fallback;

  const canonical = BUILT_IN_SOURCE_ALIASES[trimmed.toLowerCase()];
  return canonical ?? trimmed;
}
